import { useHoverPopoverClose } from '@app/components/base/HoverPopover';
import { PlayIcon } from '@app/components/playback/PlayIcon';
import { usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';
import { Timestamp } from '@mi-front/core';
import { IconButton, Tooltip } from '@mui/material';
import { useCallback } from 'react';
import { defineMessage, useIntl } from 'react-intl';

const playMessage = defineMessage({
  id: 'common.play',
  defaultMessage: 'Reproducir',
});

type PlayAtTimestampButtonProps = {
  /** Absolute timestamp to seek and play from. */
  time: Timestamp;
  disabled?: boolean;
  /** Called after play; defaults to closing the HoverPopover. */
  onDone?: () => void;
};

/**
 * Shared stream popup action: play from a timestamp and close the popover.
 */
export function PlayAtTimestampButton({ time, disabled, onDone }: PlayAtTimestampButtonProps) {
  const { $t } = useIntl();
  const play = usePlaybackPlay();
  const closePopover = useHoverPopoverClose();

  const handlePlay = useCallback(() => {
    play({
      startTs: time,
      playAfterSeek: true,
    });
    (onDone ?? closePopover)?.();
  }, [time, play, onDone, closePopover]);

  return (
    <Tooltip title={$t(playMessage)} placement="top">
      <IconButton size="small" color="secondary" onClick={handlePlay} disabled={disabled}>
        <PlayIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
